import {
  AuthenticationProvider,
  ClientContent,
  LogContextProvider,
  authentication,
} from '@ecosystem/newron-client-lib';
import { useRoute } from '@ecosystem/newron-client-routes';
import { feedback } from '@ecosystem/newron-design-system';
import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router';

import { CollectionsInsightRenderRegister } from '../public/CollectionsInsightRendererRegister/CollectionsInsightRendererRegister';
import { MultiEditRegister } from '../public/MultiEditRegister/MultiEditRegister';
import { CollectionsInsightRenderer, Proposition } from '../shared/types';
import { getUserType } from '../shared/utils';

import { PngRenderer, PngRendererData } from './components/PngRenderer/PngRenderer';
import { configItemCallbacks, getInsightInfo, multiEditCallbacks } from './components/PngRenderer/PngRendererCallbacks';
import { StatsRenderer } from './components/StatsRenderer/StatsRenderer';
import {
  getInsightInfo as getStatsInsightInfo,
  configItemCallbacks as statsRendererCallbacks,
} from './components/StatsRenderer/StatsRendererCallbacks';

const Collections = React.lazy(() => import('.'));

const pngCollectionsInsightRenderer: CollectionsInsightRenderer<PngRendererData> = {
  InsightRenderer: PngRenderer,
  getInsightInfo,
  configItemCallbacks,
};

[Proposition.Link, Proposition.Playground].forEach(proposition => {
  CollectionsInsightRenderRegister.getInstance().register(
    { proposition, type: 'base64_renderer' },
    pngCollectionsInsightRenderer
  );
  MultiEditRegister.getInstance().register(proposition, multiEditCallbacks);
});

CollectionsInsightRenderRegister.getInstance().register(
  { proposition: Proposition.Platform, type: 'statistics' },
  {
    InsightRenderer: StatsRenderer,
    getInsightInfo: getStatsInsightInfo,
    configItemCallbacks: statsRendererCallbacks,
  }
);

function Root(): JSX.Element {
  // fetch route(s) for this MFE's pages
  const collectionsRoute = useRoute('collections');
  const user = authentication.getUser();

  // handle route errors (not found etc)
  if (collectionsRoute.error) {
    throw new Error(`Problem when getting route : ${collectionsRoute.error}`);
  }

  // render nothing until routes are loaded fully
  if (collectionsRoute.isLoading) {
    return null;
  }

  return (
    <LogContextProvider tags={{ userType: getUserType(user) }} mfeName="client-collections">
      <AuthenticationProvider isGuard>
        <ClientContent>
          <React.Suspense fallback={<feedback.DotsLoader stretch height="100vh" />}>
            <Router>
              <Routes>
                <Route path={'/collections/*'} element={<Collections />} />
                <Route path="*" element={<Noop />} />
              </Routes>
            </Router>
          </React.Suspense>
        </ClientContent>
      </AuthenticationProvider>
    </LogContextProvider>
  );
}

function Noop() {
  return null;
}
export { Root };
